import { type ActionEvent, Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["experienceRadio", "resetButton"]
  declare readonly experienceRadioTargets: HTMLInputElement[]
  declare readonly resetButtonTarget: HTMLButtonElement
  declare readonly hasResetButtonTarget: boolean

  get isDefaultSelected(): boolean {
    return this.defaultExperienceRadio.checked
  }

  resetExperience(): void {
    this.defaultExperienceRadio.click()
  }

  // Resets the selected experience to the default ("Any") without firing the
  // click handlers (e.g. focus jumps)
  resetExperienceSelection(): void {
    this.defaultExperienceRadio.checked = true
    this.defaultExperienceRadio.dispatchEvent(new Event("change"))

    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.hidden = true
    }
  }

  resetIfEmpty({ currentTarget }: ActionEvent): void {
    if (!(currentTarget as HTMLInputElement).value) {
      this.resetExperience()
    }
  }

  selectExperience(): void {
    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.hidden = this.isDefaultSelected
    }
  }

  private get defaultExperienceRadio(): HTMLInputElement {
    return this.experienceRadioTargets.at(0)!
  }
}
